export default {
  /**
   * 用于在表单项名称等处后接冒号等
   * @example <el-form-item :label="$t('merge.workType') | withColon" prop="worksheetType">
   */
  withColon: (val, sign = ' :') => (val && val.length ? `${val}${sign}` : ''),
  /**
   * 用于将某个值可能为空的情况显示为 -- 等
   * @example <p>{{equipmentDetailTable.consumerCode | maybeEmpty}}</p>
   */
  maybeEmpty: (val, sign = '--') => val || sign
};



// WEBPACK FOOTER //
// ./src/lib/filters.js